import { Box, Grid, Stepper } from '@mui/material'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import { variableAPI } from '../../shared/api/VariableAPI'
import Upload from '../../components/fs-file-upload/fs-upload'
import FsDiversityVariants from '../../components/fs-diversity-variants/fs-diversity-variants'
import { Characteristic, WizardConfiguration } from '../../shared/model/models'
import FsContextModels from '../../components/fs-context-models/fs-context-models'
import FsIndependentCharacteristics from '../../components/fs-independent-characteristics/fs-independent-characteristics'
import { characteristicAPI } from '../../shared/api/CharacteristicAPI'
import { configurationAPI } from '../../shared/api/ConfigurationAPI'
import FsDescriptiveCharacteristics from '../../components/fs-descriptive-characteristics/fs-descriptive-characteristics'

const FsConfWizardView = () => {
  const { t } = useTranslation()
  const [allCharacteristics, setAllCharacteristics] = useState<Characteristic[]>([])
  const [configuration, setConfiguration] = useState<WizardConfiguration>()
  const [activeStep, setActiveStep] = useState<number>(-1)
  const [activeError, setActiveError] = useState<number>(-1)

  const loadConfiguration = () => {
    configurationAPI.getConfiguration().then((response) => {
      setConfiguration(response)
      setActiveStep(response?.activeStep.position || 0)
    }).catch((error) => {
        // Error is caught, but do nothing
      })
  }

  useEffect(() => {
    loadConfiguration()
    characteristicAPI.getCharacteristics().then((response) => {
      setAllCharacteristics(response)
    }).catch((error) => {
        // Error is caught, but do nothing
      })
  }, [])

  const initVariables = () => {
    variableAPI
      .initVariables()
      .then(() => {
        loadConfiguration()
        characteristicAPI.getCharacteristics().then((response) => {
          setAllCharacteristics(response)
        })
      })
      .catch(() => {
        setActiveError(1)
      })
  }

  const hasError = (index: number) =>
    index === configuration?.activeStep.position && index === activeError

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {configuration?.steps.map((step, index) => (
          <Step key={step.name}>
            <StepLabel error={hasError(index)}>{step.name}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {Array.isArray(allCharacteristics) && allCharacteristics.length > 0 ? (
        <Box sx={{ height: 'calc(100vh - 140px)', overflowY: 'auto', pb: 6 }}>
          {activeStep === 0 && (
            <div>
              <h1>{t('import.data')}</h1>
              <Grid container>
                <Grid size={{xs: 12, md: 8, lg: 6, xl: 4}}>
                  <Upload onSuccess={loadConfiguration} />
                </Grid>
              </Grid>
            </div>
          )}
          {activeStep === 1 && (
            <div>
              <h1>{t('init.variables')}</h1>
              <Button sx={{ mt: 1, mr: 1 }} onClick={initVariables}>
                {t('init.variables')}
              </Button>
            </div>
          )}
          {activeStep === 2 && (
            <div>
              <h1>{t('setup.diversity.variants')}</h1>
              <FsDiversityVariants
                characteristics={allCharacteristics}
                onSuccess={loadConfiguration}
              />
            </div>
          )}
          {activeStep === 3 && (
            <div>
              <h1>{t('setup.context.models')}</h1>
              <FsContextModels characteristics={allCharacteristics} onSuccess={loadConfiguration} />
            </div>
          )}
          {activeStep === 4 && (
            <div>
              <h1>{t('setup.independent.characteristics')}</h1>
              <FsIndependentCharacteristics onComplete={loadConfiguration} />
            </div>
          )}
          {activeStep === 5 && (
            <div>
              <h1>{t('setup.descriptive.characteristics')}</h1>
              <FsDescriptiveCharacteristics onComplete={loadConfiguration} />
            </div>
          )}
        </Box>
      ) : null}
    </Box>
  )
}

export default FsConfWizardView
